import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import IconLink from 'components/Shared/IconLink/Index'

const WebhookLink = ({ to }) => {
  const { t } = useTranslation()

  return (
    <Link to={to.pathname}>
      <IconLink
        iconName='icon-show-requests'
        text={t('ticketPage.webhookTicketLink')}
      />
    </Link>
  )
}

WebhookLink.propTypes = {
  to: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.string.isRequired,
  ]),
}

export default WebhookLink
